import { AANAccountType } from '@interfaces/models';

export interface MinorAccountRegistrations {
  accountId: string;
  accountType: string;
  registrationLines: string[];
  ageOfTermination: number;
  verifiedForSTP: boolean;
}

export interface AccountRegistrations {
  accountId: string;
  accountType: AANAccountType;
  registrationLines: string[];
  tin: string;
}

export interface MinorAccountRegistrationResponse {
  accountRegistrations: MinorAccountRegistrations[];
}

export interface AccountRegistrationResponse {
  accountRegistrations: AccountRegistrations[];
}
